module.exports = __webpack_public_path__ + "img/align-start.b790bef0.svg";